import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Header from "../components/header/header"
import TermsOfServiceContent from "../components/disclaimer-pages/terms-of-service-content"
import StickyNav from "../components/sticky-nav"

const PrivacyPolicy = () => (
    <Layout>
        <Helmet>
            <body className="terms-of-service-page" />
        </Helmet>
        <SEO title="Terms of Service" />
        <Header />
        <TermsOfServiceContent />
        <StickyNav />
    </Layout>
)

export default PrivacyPolicy